__turbopack_context__.v({
  "className": "monasans_f39e199c-module__fSRT_G__className",
  "variable": "monasans_f39e199c-module__fSRT_G__variable",
});
